import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useNavigate } from "react-router-dom";

const pinHtml = `<div style="transform:translate(-50%,-100%)">
  <svg width="34" height="44" viewBox="0 0 34 44" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 0C7.6 0 0 7.6 0 17c0 12 17 27 17 27s17-15 17-27C34 7.6 26.4 0 17 0z" fill="#00205B"/>
    <circle cx="17" cy="17" r="8" fill="#C5A059"/>
  </svg></div>`;

const icon = L.divIcon({ html: pinHtml, className: "th-marker", iconSize: [34, 44], iconAnchor: [17, 44] });

export default function CommunityMap({ communities }) {
  const ref = useRef(null);
  const mapRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (mapRef.current || !ref.current) return;
    const map = L.map(ref.current, { scrollWheelZoom: false }).setView([46.5, 6], 4);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; OpenStreetMap contributors', maxZoom: 19,
    }).addTo(map);
    mapRef.current = map;
    return () => { map.remove(); mapRef.current = null; };
  }, []);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    const layer = L.layerGroup().addTo(map);
    const pts = [];
    (communities || []).forEach((c) => {
      if (c.lat == null || c.lng == null) return;
      pts.push([c.lat, c.lng]);
      const m = L.marker([c.lat, c.lng], { icon }).addTo(layer);
      m.bindPopup(
        `<div style="font-family:Inter,sans-serif;min-width:160px">
          <div style="font-weight:700;color:#00205B">${c.name}</div>
          <div style="font-size:12px;color:#64748b">${c.parish || ""}, ${c.city}</div>
          <div style="font-size:12px;color:#64748b">${c.schedule || ""}</div>
          <a href="/comunidades/${c.id}" data-cid="${c.id}" class="th-popup-link" style="color:#C5A059;font-weight:600;font-size:13px;cursor:pointer">Ver comunidade →</a>
        </div>`
      );
    });
    map.on("popupopen", (e) => {
      const link = e.popup.getElement().querySelector(".th-popup-link");
      if (link) link.addEventListener("click", (ev) => { ev.preventDefault(); navigate(`/comunidades/${link.dataset.cid}`); });
    });
    if (pts.length) map.fitBounds(pts, { padding: [50, 50], maxZoom: 6 });
    return () => { layer.remove(); };
  }, [communities, navigate]);

  return <div ref={ref} data-testid="community-map" className="w-full h-[520px] rounded-2xl overflow-hidden border border-slate-200 shadow-sm z-0" />;
}
